module.exports = __webpack_public_path__ + "img/2_batteries_on_2_inputs.454765e9.png";